import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthContextProvider } from './context-storage/AuthHandler';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <BrowserRouter>
    <AuthContextProvider>
            <App />
    </AuthContextProvider>
    </BrowserRouter>
  // </React.StrictMode>
);

